var base = require('settings/subscription');

Vue.component('spark-subscription', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription.js